import { DEFAULT_VALUE_ACCESSOR } from '../../../../core/constants.js';
import { MeterBarSegment } from '../../../shared/components/meter-bar-segment/MeterBarSegment.js';
import { useMeterBarLayoutSize } from '../../../shared/context/MeterBarLayoutSizeContext.js';
import { getNumericValue } from '../../../shared/utils/get-numeric-value.js';
import { getSegmentWidth } from '../../../shared/utils/get-segment-width.js';
import { useMeterBarChartData } from '../../context/MeterBarChartDataContext.js';
import { useMeterBarChartInternalConfig } from '../../context/MeterBarChartInternalConfigContext.js';

export const MeterBarChartSegment = () => {
  const { color, value, valueAccessor } = useMeterBarChartData();
  const { min, max } = useMeterBarChartInternalConfig();
  const { segmentWidth: width } = useMeterBarLayoutSize();
  const displayValue = getNumericValue(
    value,
    valueAccessor ?? DEFAULT_VALUE_ACCESSOR,
  );

  const segmentWidth = getSegmentWidth(displayValue, min, max, width);

  return (
    <g>
      <MeterBarSegment color={color} width={segmentWidth} />
    </g>
  );
};

MeterBarChartSegment['displayName'] = 'MeterBarChartSegment';
